// const URIRaiz = "http://localhost:8080";
const URIRaiz = "https://mercadito-natural-kiara.herokuapp.com";
const URIs = {
  admins: `${URIRaiz}/admins`,
  productosAdmins: `${URIRaiz}/admins/productos`,
  categorys: `${URIRaiz}/admins/categorys`,
  imagenes: `${URIRaiz}/imgs/`,
  edicionProducto: `${URIRaiz}/admins/editar`,
  guardarEdicionProducto: `${URIRaiz}/admins/guardarEdit`,
  productosUsuarios: `${URIRaiz}/usuarios/productos`,
  ofertas: `${URIRaiz}/usuarios/ofertas`,
  enviarMensaje: `${URIRaiz}/usuarios/enviarMensaje`,
};

module.exports = URIs;
